import { useCallback } from 'react';
import type { PosterizeValue } from '../../lib/filters/posterize';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Posterize panel — single levels slider (2..32). */
export function PosterizePanel({ value, onChange }: AdjustmentPanelProps<PosterizeValue>) {
  const set = useCallback(
    (patch: Partial<PosterizeValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Levels"
        min={2}
        max={32}
        step={1}
        value={value.levels}
        onChange={(v) => set({ levels: v })}
      />
    </div>
  );
}
